import React from 'react';
import {
    LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer,
    ReferenceArea, CartesianGrid, ReferenceLine
} from 'recharts';

export default function LabTrendChart({ labs }) {
    if (!labs || labs.length === 0) return (
        <div className="text-sm text-slate-500 py-6">No results yet.</div>
    );

    const data = labs.map(l => ({
        date: (l.date || '').slice(0, 10),
        value: Number(l.value),
    }));

    const refLow = labs[0]?.ref_low;
    const refHigh = labs[0]?.ref_high;
    const unit = labs[0]?.unit || '';

    return (
        <div className="w-full h-56">
            <ResponsiveContainer>
                <LineChart data={data} margin={{ top: 8, right: 16, left: -12, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
                    <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#64748B' }} />
                    <YAxis tick={{ fontSize: 11, fill: '#64748B' }} unit={unit ? ` ${unit}` : ''} />
                    {refLow != null && refHigh != null && (
                        <ReferenceArea y1={refLow} y2={refHigh} fill="#0F3D48" fillOpacity={0.08} strokeOpacity={0} />
                    )}
                    {refLow != null && (
                        <ReferenceLine y={refLow} stroke="#0F3D48" strokeDasharray="4 4" strokeOpacity={0.4} />
                    )}
                    {refHigh != null && (
                        <ReferenceLine y={refHigh} stroke="#0F3D48" strokeDasharray="4 4" strokeOpacity={0.4} />
                    )}
                    <Tooltip
                        contentStyle={{ borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 12 }}
                        formatter={(v) => [`${v}${unit ? ' ' + unit : ''}`, 'Value']}
                    />
                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke="hsl(195, 60%, 20%)"
                        strokeWidth={2}
                        dot={{ r: 4, fill: 'hsl(195, 60%, 20%)' }}
                        activeDot={{ r: 6 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
